export const updateJsonData = (updatedData) => (dispatch) => {
	dispatch({type: 'SET_JSON_DATA' , payload: updatedData})
}